import { memo } from 'react';
import { Doc } from './Doc';
import type { FileIconProps } from './interfaces';

// The purple beam in the project Call and Survey logos (Project/Call.tsx, Project/Survey.tsx)
export const DISCUSSION_GUIDE_COLOR = '#5E5FA9';

// The amber used for warnings in the conference room (Conference.Room.Video), the only yellow in the UI
const STAR_COLOR = '#ffb700';

export const DiscussionGuideIcon = memo((props: FileIconProps) => {
  return (
    <Doc {...props} color={DISCUSSION_GUIDE_COLOR}>
      {/* Star on the bottom right corner marks a key file. The white outline keeps it clear of the page lines. */}
      <polygon
        points="18,12.95 19.54,17.08 23.94,17.27 20.5,20.01 21.67,24.26 18,21.83 14.33,24.26 15.5,20.01 12.06,17.27 16.46,17.08"
        fill={STAR_COLOR}
        stroke="#fff"
        strokeWidth="1"
        strokeLinejoin="round" />
    </Doc>
  );
});
